import { useEffect, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import jsonPath from 'jsonpath';
import { getEnvironmentMode } from '../env-config';
import firebaseDevConfig from '../../data/firebase_dev_config.json';
import firebaseDevKConfig from '../../data/firebase_devk_config.json';
import firebaseStageConfig from '../../data/firebase_stg_config.json';
import firebaseQAConfig from '../../data/firebase_qa_config.json';
import firebaseProConfig from '../../data/firebase_pro_config.json';
import firebaseProKConfig from '../../data/firebase_prok_config.json';
import { setSession } from '../../services/storage-service';
import logger from '../../services/logger';

// Initialize Firebase
if (!firebase.apps.length) {
  let firebaseConfig;
  const environmentMode = getEnvironmentMode();
  logger.info(" FIRE BASE ENV MODE %%%%%%% ", environmentMode);
  switch (environmentMode) {
    case 'dev':
      firebaseConfig = firebaseDevConfig;
      break;
    case 'devr':
      firebaseConfig = firebaseDevKConfig;
      break;
    case 'stage':
      firebaseConfig = firebaseStageConfig;
      break;
    case 'qa':
      firebaseConfig = firebaseQAConfig;
      break;
    case 'pro':
      firebaseConfig = firebaseProConfig;
      break;
    case 'tcp':
    case 'tcpehs':
    case 'omya':
    case 'pror':
    case 'uflex':
    case 'adani':
    case 'tcpsop':
      firebaseConfig = firebaseProKConfig;
      break;
    default:
      firebaseConfig = firebaseDevConfig;
      break;
  }
  firebase.initializeApp(firebaseConfig);
  // Attach firebase object to window
  window.firebase = firebase;
}

const FirebaseService = ({ businessId, bizAccountRefId, setFireBaseLoad }) => {
  const [userDataObj, setUserDataObj] = useState({});
  const [bizAccountServiceList, setBizAccountServiceList] = useState({});
  const [bizAccountConsumersList, setBizAccountConsumersList] = useState({});
  const [bizAccountObjPermissions, setBizAccountObjPermissions] = useState({});

  useEffect(() => {
    // Get a reference to the database
    const database = firebase.database();
    logger.debug(bizAccountServiceList, bizAccountConsumersList);

    // Get a reference to the specific location in the database
    const bizUserObjRef = database.ref(`/business/${businessId}/accounts/${bizAccountRefId}`);

    // Listen for data changes at the specified location
    const onDataChange = (snapshot) => {
      const data = snapshot.val();
      setUserDataObj(data);
      setBizAccountObjPermissions(data?.objPermissions);
      setSession(`${businessId}_biz_Accocunt_user_obj`, data, true);
      logger.debug(data);

      if (
        data?.objPermissions === null ||
        data?.objPermissions === undefined ||
        Object.keys(data?.objPermissions)?.length === 0
      ) {
        setTimeout(() => {
          setFireBaseLoad(true);
        }, 500);
      }
    };

    bizUserObjRef.on('value', onDataChange);

    // Clean up the listener when the component unmounts to avoid memory leaks
    return () => {
      bizUserObjRef.off('value', onDataChange);
    };
  }, [businessId, bizAccountRefId]);

  useEffect(() => {
    // Get a reference to the database
    const database = firebase.database();

    // Prepare user business operations after bizAccountObjPermissions changes
    const prepareUserBusinessOperations = () => {
      logger.info('FIREBASE');
      const promises = Object.keys(bizAccountObjPermissions).map((objType) => {
        const refPath = objType.includes('SVC')
          ? `/business/${businessId}/services/${objType}`
          : `/business/${businessId}/consumers/${objType}`;
        return database.ref(refPath).once('value');
      });

      // Use Promise.all to wait for all promises to resolve
      Promise.all(promises)
        .then((snapshots) => {
          const serviceList = {};
          const consumerList = {};

          snapshots.forEach((snapshot, index) => {
            const objType = Object.keys(bizAccountObjPermissions)[index];
            const data = snapshot.val();
            if (!data) return;
            data.type = objType;

            const isHidden = jsonPath.query(userDataObj, `$..objPermissions.${objType}.*.hiddenMode`);
            if (typeof isHidden === 'object' && isHidden.includes(true)) {
              data.isHiddenMode = true;
            }

            if (objType.includes('SVC') && data?.state === 'ACTIVE') {
              serviceList[objType] = data;
            } else if (objType.includes('USR')) {
              consumerList[objType] = data;
            }
          });

          logger.debug(serviceList);
          logger.debug(consumerList);
          setBizAccountServiceList(serviceList);
          setBizAccountConsumersList(consumerList);
          setSession(
            `${businessId}_biz_accocunt_user_consumer_list`,
            {
              bizAccountConsumersList: consumerList,
              bizAccountRefId,
            },
            true,
          );
          setSession(
            `${businessId}_biz_accocunt_user_service_list`,
            {
              bizAccountServiceList: serviceList,
              bizAccountRefId,
            },
            false,
          );
          setTimeout(() => {
            setFireBaseLoad(true);
          }, 500);
        })
        .catch((error) => {
          // Handle errors if any of the promises fail
          logger.error(error);
          setTimeout(() => {
            setFireBaseLoad(true);
          }, 500);
        });
    };

    if (
      bizAccountObjPermissions !== null &&
      bizAccountObjPermissions !== undefined &&
      Object.keys(bizAccountObjPermissions).length > 0
    ) {
      prepareUserBusinessOperations();
    }
  }, [bizAccountObjPermissions, userDataObj, businessId, bizAccountRefId]);
};

export default FirebaseService;
